module.exports = __webpack_public_path__ + "img/credit-checkup-new.5b5380ca.svg";